import styled, { css } from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { insetShadow, mediumShadow, largeShadow, subtleShadow } from 'ui/theme/shadows';
import { caption } from 'ui/theme/typography';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

export const StyledTooltip = styled(Tooltip)`
  width: 100%;
`;

export const StyledNodeTile = styled.div<{
  isDisabled?: boolean;
  accentColor?: string;
  name?: string;
}>`
  background: ${colors.white};

  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};

  box-sizing: border-box;
  box-shadow: ${subtleShadow.boxShadow};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;

  height: ${pxToRem(80)};
  padding: ${spacing.eighth};

  /**  
  * still need to handle once library is implemented
  * :drag {
  * border-width: ${spacing.eighth};
  * box-shadow: ${largeShadow.boxShadow};
  * } 
  */

  /** beta management */
  ${({ isDisabled, accentColor }) =>
    isDisabled
      ? css`
          cursor: not-allowed;
          pointer-events: none;
          background: ${colors.backgroundDisabled};
          border-color: ${colors.borderPrimary};
          box-shadow: ${subtleShadow.boxShadow};
          outline: none;
          user-select: none;
        `
      : css`
          :hover {
            box-shadow: ${mediumShadow.boxShadow};
          }

          :active,
          :focus {
            border-color: ${accentColor};
            border-width: ${spacing.eighth};
            box-shadow: ${insetShadow.boxShadow};
            outline: none;
          }
        `}
`;

const TileContent = styled.div`
  display: flex;
  flex: 1 1 50%;
  justify-content: center;
  text-align: center;
`;

export const NodeTileText = styled(TileContent)`
  ${caption};
  align-items: center;
`;

export const NodeTileIconContainer = styled(TileContent)`
  align-items: flex-end;
  position: relative;
`;
